import styled from '@emotion/styled'

import media from '../../../common/MediaQueries'
import { listReset } from '../../../common/Mixins'
import { iconBounceAnimation } from '../../../common/Animations'

export const TradeBenefitsMediaStyled = styled.div``

export const TradeBenefitsMediaContentStyled = styled.div`
  position: relative;
  max-width: 51.875rem;
  margin: 0 auto;
`

export const TradeBenefitsMediaBoxStyled = styled.div`
  position: relative;
  padding-top: 75%;

  @media ${media.tablet} {
    height: 34.375rem;
    padding-top: 0;
  }
`

export const TradeBenefitsMediaBgStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  > div {
    height: 100%;
  }
`

export const TradeBenefitsMediaListStyled = styled.ul`
  ${listReset}
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
`

export const TradeBenefitsMediaListItemStyled = styled.li`
  position: absolute;
  height: 3.625rem;
  width: 3.625rem;
  border-radius: 50%;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  animation: ${iconBounceAnimation} 1s ease-in-out infinite;

  &:nth-child(1) {
    top: 11%;
    right: 4%;
  }
  &:nth-child(2) {
    top: 54%;
    right: 0%;
    animation-delay: 0.1s;
  }
  &:nth-child(3) {
    top: 91%;
    right: 31%;
    animation-delay: 0.2s;
  }
  &:nth-child(4) {
    top: 93%;
    left: 11%;
    animation-delay: 0.3s;
  }
  &:nth-child(5) {
    top: 11%;
    left: 17%;
    animation-delay: 0.4s;
  }
`
